import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ItemList from '@client/containers/itemList/ItemList';
import { episodeRoute } from '@client/pages/routes';
import GenericHelmet from '@client/helperComponents/genericHelmet/GenericHelmet';
import VideoPlayer from '@client/containers/videoPlayer/VideoPlayer';
import PageLoaderWithTryAgain from '@client/components/pageLoader/PageLoaderWithTryAgain';
import { getSingleEpisode } from '@client/connectivity/api.episodes';
import UspSpecific from '@client/containers/uspSpecific/UspSpecific';
import FeaturedEpisodesSection from '@client/containers/featuredEpisodesSection/FeaturedEpisodesSection';
import shapes from '@client/shared/js/shapes';
import { strings } from '@client/localization/Localization';
import styles from './singleEpisodePage.scss';

class SingleEpisodePage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      series: null,
      episode: null,
      categories: null,
      episodesSameCategory: null,
      episodesSameSeries: null,
      failedToLoadContent: false,
    };
  }

  componentDidMount() {
    this.getEpisodeById();
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.getEpisodeById();
    }
  }

  getEpisodeById = () => {
    this.setState({ failedToLoadContent: false });
    const episodeId = this.props.match.params.episodeId;
    const seriesId = this.props.match.params.seriesId;
    getSingleEpisode(episodeId, seriesId)
      .then((response) => {
        this.setState({
          series: response.data.series,
          episode: response.data.episode,
          episodesSameCategory: response.data.episodesSameCategory,
          episodesSameSeries: response.data.episodesSameSeries,
        });
      })
      .catch(() => {
        this.setState({ failedToLoadContent: true });
      });
  };

  render() {
    const {
      failedToLoadContent,
      episode,
      series,
      episodesSameSeries,
      episodesSameCategory,
    } = this.state;
    if (!episode && !series) {
      return (
        <PageLoaderWithTryAgain
          onTryAgainClick={this.getEpisodeById}
          failed={failedToLoadContent}
          tryAgain={true}
        />
      );
    }

    const hasEpisodesInSameCategory =
      episodesSameCategory && episodesSameCategory.length > 0;

    return (
      <div className={styles.episodePage}>
        <div>
          <GenericHelmet
            helmetData={{
              title: episode.title,
              meta: [
                {
                  name: 'description',
                  content: episode.description,
                },
                {
                  property: 'og:title',
                  content: episode.title,
                },
                {
                  property: 'og:description',
                  content: episode.description,
                },
                {
                  name: 'twitter:description',
                  content: episode.description,
                },
                {
                  name: 'twitter:title',
                  content: episode.title,
                },
              ],
            }}
          />
          <VideoPlayer className={styles.videoPlayer} episode={episode} />
          <UspSpecific
            title={strings.aboutTheEpisode}
            description={episode.description}
            sponsor={episode.sponsor}
            categoryTitle={episode.categoryTitle}
            categoryColor={episode.categoryColor}
          />
          {episodesSameSeries && (
            <FeaturedEpisodesSection
              className={styles.episodesCarousel}
              episodes={episodesSameSeries}
              sectionTitle={strings.moreEpisodesInThisSeries}
            />
          )}
          {hasEpisodesInSameCategory ? (
            <ItemList
              className={styles.episodesSameCategory}
              items={episodesSameCategory}
              sectionTitle={strings.episodesInThisCategory}
              getItemRoute={(item) => episodeRoute(item.slug, item.seriesSlug)}
            />
          ) : (
            undefined
          )}
        </div>
        {hasEpisodesInSameCategory ? (
          <div className={styles.shapeTopRight}>
            <picture>
              <source
                media="(max-width: 768px)"
                srcSet={shapes.graphic_mall_2}
              />
              <img
                className={styles.shapeTopRight}
                src={shapes.graphic_mall_2_2x}
                alt="Factuals graphic footer"
              />
            </picture>
          </div>
        ) : (
          undefined
        )}
      </div>
    );
  }
}

SingleEpisodePage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      seriesId: PropTypes.string.isRequired,
      episodeId: PropTypes.string.isRequired,
    }),
  }),
};

export default SingleEpisodePage;
